import { IstatisticalCorrespondence } from "../../redux/types/typeReport";
import { ApiResponse } from "../ApiResponse";
import { db, firebase } from "../../config/firebase/firebase-config";
import moment from "moment";
import { CorrespondenceStatus } from "../../enums/enums";

export const getCorrespondenceStadistics = async (
  idEntity: string,
  dataPost: IstatisticalCorrespondence
): Promise<ApiResponse> => {
  try {
    const parseStartDate = firebase.firestore.Timestamp.fromDate(
      moment(dataPost.startDate).startOf("day").toDate()
    );

    const parseEndDate = firebase.firestore.Timestamp.fromDate(
      moment(dataPost.endDate).endOf("day").toDate()
    );

    let query = db
      .collection("Correspondence")
      .doc(idEntity)
      .collection("CorrespondenceSection")
      .where("createAt", ">=", parseStartDate)
      .where("createAt", "<=", parseEndDate);

    query = query.orderBy("createAt", "desc");

    // /**
    //  * Filtrar por Oficina
    //  */
    if (dataPost.office.id !== "0") {
      query = query.where("receivingDependency", "==", dataPost.office.id);
    }

    // /**
    //  * Filtrar por canal
    //  */
    if (dataPost.channel.id !== "Todos") {
      query = query.where("communicationChannel", "==", dataPost.channel.id);
    }

    var data = (await query.get()).docs.map((item) => item.data());

    /**
     * filtrar por quien recibio
     */
    if (dataPost.officerUser.name !== "Todos") {
      data = data.filter((doc) => {
        if (doc.status != CorrespondenceStatus.INACTIVE) {
          return (
            doc.addressee.id === dataPost.officerUser.id ||
            doc.externalSender === dataPost.officerUser
          );
        }
      });
    }

    // Filtrar documentos con `status !== "Inactive"`
    data = data.filter((doc) => doc.status !== "Inactive");

    return {
      ok: true,
      data: data,
      message: "Recurso obtenido con exito.",
    };
  } catch (error) {
    console.log(error);
    return {
      ok: false,
      data: null,
      message: error,
    };
  }
};
